
import Vue from 'vue'
import PointTable from '../../common/point-table/index.vue'
import PointMap from '../../common/point-map/index.vue'
import OfficeTableRow from '../../office/office-table-row/index.vue'
import staticBlockMixin from '~/mixins/staticBlockMixin'

type Tab = 'table' | 'map'
type FiltersPopup = 'region' | ''
type TypeFilter = 'office'
type RegionFilter = number

interface Data {
  activeTab: Tab,
  filtersPopup: FiltersPopup,
  typeFilter: TypeFilter,
  regionFilter: RegionFilter,
  typeFilterLabels: Record<TypeFilter, string>,
  regions: any[]
}

export default Vue.extend({
  name: 'OfficeBlock',
  components: {
    PointMap,
    PointTable,
    OfficeTableRow
  },
  mixins: [staticBlockMixin],

  data (): Data {
    return {
      activeTab: 'table',
      filtersPopup: '',
      typeFilter: 'office',
      regionFilter: 0,
      typeFilterLabels: {
        office: 'Офисы'
      },
      regions: []
    }
  },

  async fetch () {
    try {
      this.regions = (await this.$shops.fetch('office')) || []
      this.regionFilter = this.regions[0].id
    } catch (error) {
      console.error(error)
    }
  },

  computed: {
    currentRegion () {
      return this.regions?.find((region: { id: number }) => region.id === this.regionFilter) || 'Иваново'
    },
    currentFiltersShops () {
      return this.currentRegion?.shops?.filter((point: { tags: string }) => point.tags?.includes(this.typeFilter))
    }
  },

  methods: {
    showFilters (key: Omit<FiltersPopup, ''>) {
      this.filtersPopup = this.filtersPopup !== key ? key : ''
    },
    selectFilterAndHide (key: Omit<FiltersPopup, ''>, value: TypeFilter | number) {
      this.selectFilter(key, value)
      this.hideFilters()
    },
    selectFilter (key: Omit<FiltersPopup, ''>, value: TypeFilter | number) {
      this[`${key}Filter`] = value
    },
    hideFilters () {
      this.filtersPopup = ''
    },
    changeTab (tab: Tab) {
      this.activeTab = tab
    }
  }
})
